"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Plan = function Plan(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.09 8.43v3.09h-1.8V2.76h3.42c.66 0 1.23.12 1.74.36s.9.57 1.14 1.02c.27.45.39.96.39 1.53 0 .87-.3 1.53-.87 2.04-.57.51-1.41.75-2.43.75H6.09v-.03zm0-1.47h1.62c.48 0 .84-.12 1.08-.33.24-.24.39-.54.39-.96 0-.42-.12-.78-.39-1.05-.24-.27-.6-.39-1.05-.42H6.09v2.76z",
    fill: color,
    fillOpacity: 0.5
  }));
};
var _default = exports["default"] = Plan;